
  $(document).ready(function(){

    if($("#map-poland").length > 0){
      $("#map-poland").CSSMap({
        "size": 960,
        onClick: function (listItem) {
          console.log(listItem);
        },
        agentsList: {
          enable: false,
          agentsListId: "#manufactory-list"
        },
        pins: {
          enable: true,
          pinsId: "#manufactory-markers",
          mapSize: 960
        }
      });

      $(window).bind( 'hashchange', function(e) {
        var  region = window.location.hash.substring(1);
        $('.manufactory-item-wrap[data-region]').addClass('hidden');
        $('.manufactory-item-wrap[data-region="' + region + '"]').removeClass('hidden');
        $('.manufactory-item-wrap[data-region] .collapse').collapse('hide');

        var body = $("html, body");
        var offsetTop  = $('.manufactory-list').offset().top - $('.page-header').outerHeight() - 150;
        body.stop().animate({scrollTop: offsetTop}, '500', 'swing', function() {});
      });

      if(window.location.hash != ""){
        var  region = window.location.hash.substring(1);
        $('.manufactory-item-wrap[data-region="' + region + '"]').removeClass('hidden');
      }

      $('.cssmap-marker').click(function(e){
        var region = $(this).data('region');
        var id = $(this).data('id');
        $('#map-poland').find('a[href="#' + region + '"]').trigger('click');
        $('.manufactory-item-wrap[data-id="' + id + '"] .manufactory-item').trigger('click');

        var body = $("html, body");
        var offsetTop  = $('.manufactory-item-wrap[data-id="' + id + '"] .manufactory-item').offset().top - $('.page-header').outerHeight() - 150;
        body.stop().animate({scrollTop: offsetTop}, '500', 'swing', function() {});

        e.preventDefault();
      });

    }


  });
